import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaEnvelope,
} from "react-icons/fa";

import { db } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import Navbar from "../inc/Navbar";
import HomeForm from "./HomeFrom";

function Contactus() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "contacts"), {
        ...formData,
        createdAt: serverTimestamp(),
      });

      alert("Message Submitted Successfully");

      setFormData({
        name: "",
        email: "",
        mobile: "",
        message: "",
      });
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <>
    <Navbar/>
    <br/>
    <br/>
    <br/>
      {/* ================= CONTACT PAGE ================= */}

      <div style={styles.container}>
        <div style={styles.overlay}>
          <h4 style={styles.smallTitle}>CONTACT US</h4>

          <h1 style={styles.heading}>
            Building Your <span style={styles.gold}>Dream Property</span>
          </h1>

          <p style={styles.description}>
            Contact our team and collaborate with us to build your dream home
            and premium property investment.
          </p>

          {/* ================= CONTACT BOX ================= */}

          <div style={styles.infoWrapper}>
            <div style={styles.infoBox}>
              <FaPhoneAlt style={styles.icon} />
              <h3>Call Us</h3>
              <p>+91 8371830744</p>
            </div>

            <div style={styles.infoBox}>
              <FaEnvelope style={styles.icon} />
              <h3>Email</h3>
              <p>tskrealtors.care@gmail.com</p>
            </div>

            <div style={styles.infoBox}>
              <FaMapMarkerAlt style={styles.icon} />
              <h3>Location</h3>
              <p>Krishnagar, Nadia, West Bengal</p>
            </div>
          </div>

          {/* ================= FORM ================= */}
          <div className="cardbackcontact">
                     <HomeForm/>
                     </div>
        </div>
      </div>

      {/* ================= FLOATING BUTTONS ================= */}

      <div style={styles.floatingContainer}>
        <a href="tel:+918371830744" style={styles.callBtn}>
          <FaPhoneAlt />
        </a>

        <a
          href="https://wa.me/918371830744"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.whatsappBtn}
        >
          <FaWhatsapp />
        </a>
      </div>
    </>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundImage:
      "url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1400')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "#fff",
  },

  overlay: {
    background: "rgba(0,0,0,0.82)",
    minHeight: "100vh",
    padding: "60px 20px",
  },

  smallTitle: {
    color: "#cfa64e",
    letterSpacing: "2px",
    fontSize: "18px",
    marginBottom: "15px",
  },

  heading: {
    fontSize: "58px",
    fontWeight: "700",
    maxWidth: "700px",
    marginBottom: "20px",
  },

  gold: {
    color: "#d4af37",
    fontStyle: "italic",
  },

  description: {
    maxWidth: "700px",
    fontSize: "18px",
    lineHeight: "32px",
    color: "#ddd",
    marginBottom: "50px",
  },

  infoWrapper: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
    marginBottom: "50px",
  },

  infoBox: {
    background: "#111",
    padding: "30px",
    borderRadius: "15px",
    minWidth: "250px",
    flex: "1",
    border: "1px solid rgba(255,255,255,0.08)",
  },

  icon: {
    fontSize: "30px",
    color: "#d4af37",
    marginBottom: "15px",
  },

  form: {
    maxWidth: "700px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },

  input: {
    padding: "16px",
    borderRadius: "10px",
    border: "none",
    background: "#1b1b1b",
    color: "#fff",
    fontSize: "16px",
  },

  textarea: {
    padding: "16px",
    borderRadius: "10px",
    border: "none",
    background: "#1b1b1b",
    color: "#fff",
    fontSize: "16px",
  },

  button: {
    background: "#d4af37",
    color: "#000",
    padding: "16px",
    border: "none",
    borderRadius: "10px",
    fontSize: "18px",
    fontWeight: "700",
    cursor: "pointer",
  },

  floatingContainer: {
    position: "fixed",
    right: "20px",
    bottom: "30px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    zIndex: 999,
  },

  callBtn: {
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    background: "#111",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontSize: "26px",
    textDecoration: "none",
  },

  whatsappBtn: {
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    background: "#25D366",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontSize: "30px",
    textDecoration: "none",
  },
};

export default Contactus;